import React, { forwardRef } from 'react';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import * as R from 'ramda';

const chipStyle = {
  '& > .MuiChip-label': { px: 0 },
  borderRadius: 0.5,
  fontSize: 12,
  fontWeight: 'normal',
  height: 20,
  maxWidth: 95,
  px: 1,
  py: 0.5,
  width: 'min-content',
};

/** Contains strings for batch statuses as a single source of truth. */
export const OLD_STATUS_CHIP = {
  CANCELED: 'Canceled',
  CANNOT_BOOK: 'Cannot Book',
  EXPIRED: 'Expired',
  IN_TRANSIT: 'In Transit',
  PROCESSING: 'Processing',
  SHIPPED: 'Shipped',
  UNCONFIRMED: 'Unconfirmed',
};

const OldStatusChip = forwardRef(function OldStatusChip(props, ref) {
  const customStyle = R.cond([
    [
      R.equals(OLD_STATUS_CHIP.CANNOT_BOOK),
      R.always({ backgroundColor: 'error.dark', color: 'surface.white' }),
    ],
    [R.equals(OLD_STATUS_CHIP.UNCONFIRMED), R.always({ backgroundColor: 'warning.main' })],
    [R.equals(OLD_STATUS_CHIP.PROCESSING), R.always({ backgroundColor: 'success.light' })],
    [R.equals(OLD_STATUS_CHIP.IN_TRANSIT), R.always({ backgroundColor: 'success.light' })],
    [R.equals(OLD_STATUS_CHIP.SHIPPED), R.always({ backgroundColor: 'primary.light' })],
    [R.equals(OLD_STATUS_CHIP.EXPIRED), R.always({ backgroundColor: 'success.lighter' })],
    [R.equals(OLD_STATUS_CHIP.CANCELED), R.always({ backgroundColor: 'graphic.light' })],
  ]);

  return (
    <Chip
      {...props}
      label={props.status}
      ref={ref}
      sx={{ ...chipStyle, ...customStyle(props.status), cursor: 'pointer' }}
    />
  );
});

OldStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default OldStatusChip;
